import {Component, OnInit} from '@angular/core';
import {NewsService} from "../../../shared/services/news.service";

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
    news: any;

    constructor(
        private newsService: NewsService
    ) {
    }

    ngOnInit(): void {
        window.scroll(0, 0);
        this.get();
    }

    get() {
        this.newsService.get({status: 'ACTIVE'}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.news = data['data'];
            }
        })
    }

    goTo(url: any) {
        window.open(url, '_blank');
    }

}
